import { Button, Heading, Inline, PageBlock, Stack, vars } from '@etg/wings';
import mealImage from '@eti/assets/images/products/order/meal.jpg';
import checkInBaggageImage from '@eti/assets/images/products/order/checkInBaggage.jpg';
import baggageServiceImage from '@eti/assets/images/products/order/baggageService.jpg';
import onlineCheckInImage from '@eti/assets/images/products/order/onlineCheckIn.jpg';
import { onlineCheckIn, meal, checkInBaggage, baggageService } from '@eti/products';
import { useTranslation } from '@eti/providers';
import { css } from '@eti/styles';
import ReceiptProductBlock from './ReceiptProductBlock';

const blockStyles = css`
  border-top: 1px solid ${vars.colors.divider};
`;

const containerClass = css`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`;

const postBookingButtonStyles = css`
  min-width: 240px;
`;

interface ReceiptExtraProductsProps {
  postBookingUrl: string;
}

const ReceiptExtraProducts = ({ postBookingUrl }: ReceiptExtraProductsProps) => {
  const { t } = useTranslation();

  return (
    <PageBlock
      aria-labelledby="receipt-products-heading"
      as="section"
      className={blockStyles}
      withPaddingY
    >
      <Stack spacing={24}>
        <Heading id="receipt-products-heading" level={2}>
          {t('Receipt.ExtraProducts.Heading')}
        </Heading>
        <div className={`block-container ${containerClass}`}>
          <ReceiptProductBlock
            icons={onlineCheckIn.getIcon()}
            image={onlineCheckInImage}
            labelText={t('Receipt.ExtraProducts.LabelOnlineCheckIn')}
            postBookingUrl={postBookingUrl}
          />
          <ReceiptProductBlock
            icons={meal.getIcon()}
            image={mealImage}
            labelText={t('Receipt.ExtraProducts.LabelMeal')}
            postBookingUrl={postBookingUrl}
          />
          <ReceiptProductBlock
            icons={checkInBaggage.getIcon()}
            image={checkInBaggageImage}
            labelText={t('Receipt.ExtraProducts.LabelCheckInBaggage')}
            postBookingUrl={postBookingUrl}
          />
          <ReceiptProductBlock
            icons={baggageService.getIcon()}
            image={baggageServiceImage}
            labelText={t('Receipt.ExtraProducts.LabelBaggageService')}
            postBookingUrl={postBookingUrl}
          />
        </div>
        <Inline align="center">
          <Button
            as="a"
            className={postBookingButtonStyles}
            data-testid="order-postBooking-link"
            href={postBookingUrl}
            variant="primary"
          >
            {t('Receipt.ExtraProducts.TextButton')}
          </Button>
        </Inline>
      </Stack>
    </PageBlock>
  );
};

export default ReceiptExtraProducts;
